var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBicicletaVerde(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 67,
    viewBox: "0 0 65 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9223",
    "data-name": "Group 9223",
    transform: "translate(587 -454)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13490",
    "data-name": "Rectangle 13490",
    width: 65,
    height: 67,
    rx: 32.5,
    transform: "translate(-587 454)",
    fill: "#00ca7d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_003-bicicleta",
    "data-name": "003-bicicleta",
    transform: "translate(-575.287 475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M32.465,105.3a8.279,8.279,0,0,0-2.987.555,23.494,23.494,0,0,1-1.668-4.913,5.477,5.477,0,0,0-5.363-4.4,1.195,1.195,0,0,0,0,2.39,3.083,3.083,0,0,1,2.7,1.608,1.191,1.191,0,0,0-.09.129l-.371.625-1.878,3.162H12.776l-.57-1.436h.237a1.195,1.195,0,0,0,0-2.39H8.322a1.195,1.195,0,0,0,0,2.39H9.634l1.043,2.624a8.322,8.322,0,1,0,5.882,9.178h2.194a1.2,1.2,0,0,0,1.027-.585l6.28-10.572a31.861,31.861,0,0,0,1.326,3.373,8.318,8.318,0,1,0,5.079-1.734ZM8.322,114.814h5.811a5.932,5.932,0,1,1,0-2.39H8.322a1.195,1.195,0,0,0,0,2.39Zm9.751-2.39H16.558a8.312,8.312,0,0,0-2.568-4.893,1.2,1.2,0,0,0-.046-.143l-.219-.551h7.666Zm14.392,7.127a5.93,5.93,0,0,1-4-10.313,52.906,52.906,0,0,0,3.013,5.059,1.195,1.195,0,0,0,1.967-1.358,52.243,52.243,0,0,1-2.92-4.927,5.932,5.932,0,1,1,1.936,11.539Z",
    transform: "translate(0 -96.534)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicicletaVerde);
export default __webpack_public_path__ + "static/media/BicicletaVerde.e887d3e66616b80f2dfecc475523fa1b.svg";
export { ForwardRef as ReactComponent };